import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';

import { getFiscalDataConfig } from '@/services/invoice';

import { destinoDoPasso } from '../../functions/notaAvulsa';
import { NFSE_FISCAL_DATA_CONFIG_KEY } from '../../hooks/Dashboard/useNFSeCompanyStatus';

/**
 * Leva ao passo do cadastro fiscal que falta: o wizard naquele passo, ou a edição para quem já
 * tem o cadastro de vendas salvo (o wizard recusa quem já tem dados fiscais).
 *
 * O cadastro é lido no clique, e não na montagem: quem só lê o aviso não paga a consulta. Sem
 * resposta, vale o wizard, que confere de novo e manda para a edição se for o caso.
 */
export function useIrParaPassoDoCadastro() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return useCallback(
    async (chave) => {
      let configurado = false;
      try {
        configurado = Boolean(
          await queryClient.fetchQuery({
            queryKey: NFSE_FISCAL_DATA_CONFIG_KEY,
            queryFn: () => getFiscalDataConfig(),
            staleTime: 5 * 60 * 1000,
          })
        );
      } catch {
        configurado = false;
      }

      navigate(destinoDoPasso({ chave }, { configurado }));
    },
    [navigate, queryClient]
  );
}
